import {PhoneHQTooltip} from "ch3-ui-lib";
import {fullName, getTeamGroup, isInMeeting, TeamMember} from "./teamFilters";
import {LocalTimeWithZone, MemberAvatar, StatusDot} from "./TeamMemberParts";
import {formatUntil, groupLabel} from "./teamFormat";
import TeamMemberActions from "./TeamMemberActions";
import {SelectCheckbox} from "../../features/callSurface/team/SelectCheckbox";

/** One colleague in the Team tab's list view. */
const TeamRow = ({user, selected, onToggleSelected}: {user: TeamMember; selected?: boolean; onToggleSelected?: () => void}) => {
    const name = fullName(user);
    const group = getTeamGroup(user);
    const meetingUntil = formatUntil(user.meetingUserStatus?.dateTo);

    return (
        <div data-testid="team-row" className="flex items-center gap-4 px-4 py-3">
            {onToggleSelected && <SelectCheckbox name={name} checked={!!selected} onToggle={onToggleSelected}/>}
            <div className="flex min-w-0 flex-[2] items-center gap-3">
                <MemberAvatar member={user} size="sm"/>
                <div className="min-w-0">
                    <PhoneHQTooltip content={name}><div className={'truncate font-semibold text-ink'}>{name}</div></PhoneHQTooltip>
                    {Boolean(user.position) &&
                        <div className={'truncate text-sm text-ink-muted'}>{user.position}</div>}
                </div>
            </div>

            <div className={'hidden min-w-0 flex-[2] truncate text-sm md:block text-ink-muted'}>
                {user.email}
            </div>

            <LocalTimeWithZone timeZone={user.userTimeZone} className="hidden w-[180px] shrink-0 lg:flex" fallback="—"/>

            <div className="w-[140px] shrink-0">
                {isInMeeting(user) ? (
                    <span data-testid="team-meeting" className="inline-flex max-w-full items-center rounded-full bg-danger-tint px-2.5 py-1 text-xs font-medium text-danger-ink">
                        <span className="truncate">{meetingUntil ? `Until ${meetingUntil}` : 'In a meeting'}</span>
                    </span>
                ) : (
                    <span className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-canvas px-2.5 py-1 text-xs font-medium text-ink-secondary">
                        <StatusDot group={group}/>
                        <span className="truncate">{groupLabel(group)}</span>
                    </span>
                )}
            </div>

            <TeamMemberActions member={user}/>
        </div>
    );
};

export default TeamRow;
